  <div class="flex flex-column">
    <div class="flex align-items-center gap-2">
      <div>
        <img src="/assets/images/no-user-image.png" class="user-image">
      </div>
      <div>
        <h2>{{extension.exten}}</h2>
        <h3>{{extension.description}}</h3>
      </div>
    </div>

    <div class="pt-4 p-datatable">
      <p-table [value]="[1]" >
        <ng-template pTemplate="body" let-extension let-columns="columns">
          <tr>
            <td width="200">Servidor SIP</td>
            <td>{{pbxserver}}</td>
          </tr>
          <tr>
            <td>Usuario</td>
            <td>{{user.userName}}</td>
          </tr>
          <tr>
            <td>Contraseña</td>
            <td>{{user.sipExtensionPassword}}</td>
          </tr>
          <tr>
            <td>Servidor</td>
            <td>{{pbxserver}}:{{pbxport}}</td>
          </tr>
          <tr>
            <td>Transporte</td>
            <td>{{user.sipTransport}}</td>
          </tr>
          <tr>
            <td>Codecs</td>
            <td>alaw</td>
          </tr>
          <tr>
            <td>Teléfono saliente</td>
            <td>
              <div *ngIf="ddi!=null">{{ddi?.phoneNumber}} ({{ddi?.name}})</div>
            </td>
          </tr>
          <tr>
            <td>Url contactos Microsip</td>
            <td>{{microsipDirectoryUrl}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>